<template>
  <span
    :class="sbStatusVariationClasses"
    data-sb-regression="sb-status"
  />
</template>
<script>
export default {
  name: 'SbStatus',
  props: {
    variation: {
      type: String,
      default: 'on',
      validator: (value) => {
        return value.match(/(on|off)/);
      },
    },
    size: {
      type: String,
      default: 'small',
      validator: (value) => {
        return value.match(/(small|medium)/);
      },
    },
  },
  computed: {
    sbStatusVariationClasses() {
      return ['sb-status', `sb-status--${this.variation}`, `sb-status--${this.size}`];
    },
  },
};
</script>
<style scoped lang='scss'>
@import '@src/components/Status/style/sb-status.scss';
</style>
